import React from 'react';
import UnitDetails from '../components/unitDetails';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

const UnitDetailsPage = () => {

    const canReadUnit = hasPermission("Properties & Units", "Unit", "read");
    const navigate = useNavigate();

    if (!canReadUnit) {
        navigate('/no-permission');
    }

    return <UnitDetails />;
};

export default UnitDetailsPage;
